import { ScrollView, Text, View } from 'react-native'
import { useSafeAreaInsets } from 'react-native-safe-area-context'
import { useTranslation } from 'react-i18next'

import type { BuyQueryResult, SellQueryResult } from '@/types/common'
import { Button } from '@/components/base'
import BottomActionPanel from '@/components/BottomActionPanel'
import { ChildOrderDetailSection } from '@/components/orders/child/DetailSection'
import { ChildOrderPaymentSection } from '@/components/orders/child/PaymentSection'

export function ChildOrderCancelingScreen({
  data,
  type,
  parentInternalKey,
  requestAppeal
}: {
  data:
    | BuyQueryResult['userGetBuyOrderByInternalKey']
    | SellQueryResult['userGetSellOrderByInternalKey']['pairBuyOrder'][number]
  type: 'buy' | 'sell'
  parentInternalKey?: string
  requestAppeal: () => void
}) {
  const { t } = useTranslation()
  const { bottom } = useSafeAreaInsets()
  return (
    <>
      <View className={'flex-1 bg-background-secondary'}>
        <ScrollView className={'flex-1'} contentContainerStyle={{ paddingBottom: bottom + 72 }}>
          <View className={'gap-2 border-b border-border-10 bg-background-primary px-4 pb-[11px] pt-2'}>
            <Text className={'text-2xl font-semibold text-text-primary'}>
              {t(type === 'buy' ? 'orders:sellerCancelling' : 'orders:cancelling')}
            </Text>
            <Text className={'text-sm text-text-secondary'}>
              {t('orders:orderCancellationInProgress')}
            </Text>
          </View>
          <ChildOrderDetailSection data={data} type={type} parentInternalKey={parentInternalKey} />
          <ChildOrderPaymentSection data={data} type={type} />
        </ScrollView>
        <BottomActionPanel>
          {type === 'sell' && (
            <Button
              size={'md'}
              intent={'primary'}
              variant={'outline'}
              onPress={() => {
                requestAppeal()
              }}
              className={'flex-1'}
            >
              {t('orders:startAppeal')}
            </Button>
          )}
        </BottomActionPanel>
      </View>
    </>
  )
}
